import { PureComponent } from "react";
import colors from "styles/colors";

import TextPartComponent from "/components/core/one-pager/desktop-content/text-part/text-part-component";
import BackgroundTriangleComponent from "/components/enhancements/decorators/background-triangle/background-triangle-component";
import { withAbTests } from "/contexts/ab-tests-context";

import { getAssetPath } from "/services/assets-service";
import classnames from "classnames";
import Picture from "/components/core/picture/picture-component";

import componentStyles from "./desktop-content-component.scss";

class DesktopContentComponent extends PureComponent {
  getSegmentHeight() {
    const { imageWithBackgroundPart } = this.props;
    return imageWithBackgroundPart.imageSegmentHeight || "100vh";
  }

  render() {
    const { textPart, signupForm = {}, collaborationWith, imageWithBackgroundPart } = this.props;
    signupForm.focusOnLoad = true;

    const alignText = imageWithBackgroundPart.imageAlign;
    return (
      <div
        className={classnames("desktop-content-component", {
          "straight-border": imageWithBackgroundPart.straightBorder
        })}
        style={{ height: `calc(${this.getSegmentHeight()} - 65px)` }}
      >
        <div className="text-part-wrapper">
          <TextPartComponent {...textPart} signupForm={signupForm} collaborationWith={collaborationWith} />
        </div>

        <div className="image-wrapper">
          <BackgroundTriangleComponent
            borderColor={imageWithBackgroundPart.backgroundColor}
            straightBorder={imageWithBackgroundPart.straightBorder}
          />
          <div className={classnames("image-part-wrapper", alignText)}>
            <Picture src={getAssetPath(imageWithBackgroundPart.src)} alt={imageWithBackgroundPart.alt} />
          </div>
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

export default withAbTests(DesktopContentComponent);
